module.exports = __webpack_public_path__ + "static/img/qualifications_icon_09.303a43b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/qualifications_icon_09.png
// module id = KNup
// module chunks = 3